import styles from "./InfoCard.module.scss";
import { ReactNode } from "react";
import { ButtonLink } from "../../../Button/Button";
import { Picture } from "@/components/shared/Picture/Picture";
import { ImageQueryResult } from "@/sanity/queries";

interface InfoCardProps {
	heading: string;
	children: ReactNode;
	image?: ImageQueryResult | null;
	buttonLabel?: string | null;
	buttonHref?: string | null;
}

export const InfoCard = ({
	heading,
	children,
	image,
	buttonLabel = "Contact Solstice",
	buttonHref = "/contact-us",
}: InfoCardProps) => {
	return (
		<article className={styles["info-card"]}>
			{image?.image && (
				<div className={styles["info-card__image"]}>
					<Picture
						className={styles["info-card__picture"]}
						sanityImage={image.image}
						alt={image.altText}
						width={600}
						height={261}
						crop
					/>
				</div>
			)}

			<div className={styles["info-card__body"]}>
				<div className={styles["info-card__copy"]}>
					<h3 className={styles["info-card__heading"]}>{heading}</h3>
					{children}
				</div>

				{buttonHref && buttonLabel && (
					<ButtonLink
						theme="tertiary"
						href={buttonHref}
						label={buttonLabel}
						className={styles["info-card__button"]}
					/>
				)}
			</div>
		</article>
	);
};
